<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="490"
      dark
    >
      <v-card 
        v-if="value"       
        style="opacity: 90%;"
      >
        <v-card-title class="text-h5">
          {{ getTranslation(value.Title, locale)}}
          <v-spacer/>
          <v-btn
            color="#CCCCCC"
            fab
            x-small
            elevation="0"
            @click="onClose"
          >
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          {{ getTranslation(value.Description, locale)}}
        </v-card-text>
          <div
            v-if="value.Info"
            class="result-html"
            style="padding: 0 25px 20px 25px;"
            :style="{
              maxWidth: '490px'
            }"
          >

            <v-flex
              v-html="getTranslation(value.Info, locale)" 
              class="ql-editor ql-blank"
              style="color: white;"
            />
          </div>
          <v-img
            v-if="value.Image"
            :src="value.Image"
            width="100%"
          />
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import utilsService from '@/services/utils'
export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
    locale: {
      type: String,
      requried: true,
    },
  },
  data: () => ({
    dialog: false,
  }),
  watch: {
    value () {
      this.dialog = this.value ? true : false
    },
  },
  methods: {
    getTranslation (v, locale) {
      if (!v) return ''
      return utilsService.getTranslation(v, locale)
    },
  },
}
</script>
<style>
  .ql-editor p {
    font-size: var(--FontSizeContent);
  }
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }   
</style>

